export default [
    {
        path: '/depots',
        name: 'Depots',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: ['SALES'],
            title: 'Depots',
        },
        components: {
            default: () => import('@views/depots/DepotsIndex.vue'),
        },
    },
    {
        path: '/depots/create',
        name: 'DepotsCreate',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: ['SALES'],
            title: 'Depots',
        },
        components: {
            default: () => import('@views/depots/DepotsCreate.vue'),
        },
    },
    {
        path: '/depots/:id/edit',
        name: 'DepotsEdit',
        props: {
            default: (route) => ({ id: route.params.id }),
        },
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: ['SALES'],
            title: 'Depots',
        },
        components: {
            default: () => import('@views/depots/DepotsEdit.vue'),
        },
    },
];
